module.exports = __webpack_public_path__ + "media/images/icon__link@2x-f2331c0ee15f07e2f6265ef124a2aa3b.png";